module.exports = __webpack_public_path__ + "9e86dce6a3a3046eab3a8cd6f6cd87ff.svg";